import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {OfflineContainerComponent} from "./landing/container/offline-container/offline-container.component";
import {LoginComponent} from "./landing/login/login.component";
import {AuthGuard} from "./core/guards/auth.guard";
import {LoginConfirmationComponent} from "./landing/login-confirmation/login-confirmation.component";
import {VideoLinkComponent} from "./main/video-link/video-link.component";

const routes: Routes = [
  {path: 'login', component: OfflineContainerComponent, children: [
      {path: '', component: LoginComponent},
      {path: 'confirmation', component: LoginConfirmationComponent},
    ]},
  {path: 'video', component: VideoLinkComponent},
  {path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./main/website.module').then(m => m.WebsiteModule)},
  {path: '**', redirectTo: 'login', pathMatch: "full"}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RoutingModule { }
